import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Icon from '../../../ui/Icon';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/Spinner.scss';

export default function Spinner({
    children,
    className,
    ...props
}) {
    const classes = classNames(styles.spinner, className);
    return (
        <div {...props} className={classes}>
            {children || (
                <div className={styles.body}>
                    <Icon name='refresh' spin fixedWidth />{' '}
                    <FormattedMessage id='common.helper.please_wait' />
                </div>
            )}
        </div>
    );
}

Spinner.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
